import { render, staticRenderFns } from "./trainOrder.vue?vue&type=template&id=b0fb8722&"
import script from "./trainOrder.vue?vue&type=script&lang=ts&"
export * from "./trainOrder.vue?vue&type=script&lang=ts&"
import style0 from "./trainOrder.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports